import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import BrowseType from "../constants/BrowseType";

export interface createBrowsePageState {
  activeTab?: BrowseType;
}

const initialState: createBrowsePageState = {};

export const createBrowsePageSlice = createSlice({
  name: "browsePage",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<BrowseType>) => {
      state.activeTab = action.payload;
    },
    resetBrowsePageState: () => initialState,
  },
});

export const { setActiveTab, resetBrowsePageState } =
  createBrowsePageSlice.actions;

export default createBrowsePageSlice.reducer;
